import React, { useState } from "react";
import { Cross, TaxNudge } from "../../../icons";

interface TaxFilingBannerProps {
  onClose: () => void; // Changed to required
  onKnowMore?: () => void;
}

const TaxFilingBanner: React.FC<TaxFilingBannerProps> = ({
  onClose,
  onKnowMore = () => {},
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="w-full bg-[#faf5e5] border border-[#ecd996] rounded-lg p-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="text-gray-800">
          <TaxNudge />
        </div>
        <div>
          <h2 className="text-[20px] font-bold text-[#090909]">
            Introducing Tax filing
          </h2>
          <p className="text-[#090909] text-[16px]">
            Effortless tax filing with an exclusive 1% Club discount
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onKnowMore}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded-full transition-colors text-[16px]"
        >
          Know more
        </button>
        <button
          onClick={handleClose}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close"
        >
          <Cross />
        </button>
      </div>
    </div>
  );
};

export default TaxFilingBanner;
